import { h, Component } from 'preact';
import Snackbar from 'material-ui/Snackbar';
import { connect } from 'preact-redux';
import { langPack } from '../../../utils/langPack';
import style from './style.scss';

class Call extends Component {
    render({ onClick, isShown, locale }) {
      return (<div>
          <Snackbar
            open={isShown}
            message={langPack[locale].COMMUNICATION.CALL_WILL_BE_FINISHED}
            onRequestClose={onClick}
            action="ok"
            onActionClick={onClick}
            style={{ top: 0, bottom: undefined, transform: isShown ? 'translate(-50%, 0)' : 'translate(-50%, -48px)',}}
            bodyStyle={{ background: '#e5002f', maxWidth: 700, minWidth: 539 }}
            contentStyle={{ fontSize: 20, display: 'flex' }}
            className={style.notification}
          />
      </div>)
    }
}


export default Call;


// WEBPACK FOOTER //
// ./components/communication/notification/index.js